import { Component, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-widerruf',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './widerruf.component.html',
})
export class WiderrufComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Widerrufsbelehrung · Craftly',
      description: 'Widerrufsrecht für Verbraucher auf der Craftly-Plattform inklusive Muster-Widerrufsformular.',
      path: '/widerruf',
      type: 'article',
    });
  }
}
